const config = {
  // Use environment variable or fallback to AWS Lambda, strip trailing slash if present
  API_BASE_URL: (process.env.REACT_APP_API_URL || "https://nkn67ii6ghwoehxyrypw6b4ilq0smrpd.lambda-url.us-east-1.on.aws").replace(/\/$/, ""),
  // Streaming Lambda URL — falls back to the main API URL if not set
  STREAMING_API_URL: (process.env.REACT_APP_STREAMING_URL || "https://z2wry6okarkp5eizee5qzwxnsy0igthc.lambda-url.us-east-1.on.aws").replace(/\/$/, ""),
  // Public landing/marketing site URL
  LANDING_URL: (process.env.REACT_APP_LANDING_URL || "https://zyntegrate.com").replace(/\/$/, ""),
};

export default config;